export const DEFAULT_INTERVALO_GRADE = 30;

export const normalizarHora = (valor) => String(valor || "").slice(0, 5);

export const horaParaMinutos = (hora) => {
  const normalizada = normalizarHora(hora);
  if (!normalizada) return null;
  const [horas, minutos] = normalizada.split(":").map(Number);
  if (!Number.isFinite(horas) || !Number.isFinite(minutos)) return null;
  return horas * 60 + minutos;
};

export const minutosParaHora = (total) =>
  `${String(Math.floor(total / 60)).padStart(2, "0")}:${String(
    total % 60
  ).padStart(2, "0")}`;

export const obterIntervaloGrade = (config = {}) => {
  const valor = Number(config.intervalo_minimo_atendimento);
  if (Number.isFinite(valor) && valor > 0) return valor;
  if (valor === 0) return 0;
  return DEFAULT_INTERVALO_GRADE;
};

export const horarioAlinhadoComGrade = (
  horaMinutos,
  aberturaMinutos,
  intervaloMinutos
) => {
  if (!intervaloMinutos || intervaloMinutos <= 0) return true;
  const diff = horaMinutos - aberturaMinutos;
  if (diff < 0) return false;
  return diff % intervaloMinutos === 0;
};

export const calcularProximoHorarioGrade = ({
  horaMinutos,
  aberturaMinutos,
  intervaloMinutos,
  fechamentoMinutos = null,
}) => {
  if (!intervaloMinutos || intervaloMinutos <= 0) {
    return Number.isFinite(horaMinutos) ? horaMinutos : aberturaMinutos;
  }

  let candidato = aberturaMinutos;
  if (Number.isFinite(horaMinutos) && horaMinutos > aberturaMinutos) {
    const diff = horaMinutos - aberturaMinutos;
    const passos = Math.ceil(diff / intervaloMinutos);
    candidato = aberturaMinutos + passos * intervaloMinutos;
  }

  if (
    Number.isFinite(fechamentoMinutos) &&
    candidato >= fechamentoMinutos
  ) {
    return null;
  }

  return candidato;
};

export const calcularFimGradeSelect = (fechamento, intervaloMinutos) => {
  if (!fechamento) return "23:30";
  const fechamentoMin = horaParaMinutos(fechamento);
  if (fechamentoMin == null) return fechamento;
  if (!intervaloMinutos || intervaloMinutos <= 0) return fechamento;
  const ultimo = fechamentoMin - intervaloMinutos;
  return ultimo >= 0 ? minutosParaHora(ultimo) : fechamento;
};

export const validarSlotGradeDisponibilidade = ({
  hora,
  intervaloMinutos,
  abertura,
  fechamento = null,
  horariosExistentes = [],
  horaIgnorar = null,
}) => {
  const horaNorm = normalizarHora(hora);
  const horaMin = horaParaMinutos(horaNorm);
  const aberturaMin = horaParaMinutos(abertura);
  const fechamentoMin = fechamento ? horaParaMinutos(fechamento) : null;

  if (horaMin == null) {
    return { valido: false, mensagem: "Horário inválido." };
  }

  if (aberturaMin == null) {
    return {
      valido: false,
      mensagem:
        "Configure o horário de abertura do dia antes de cadastrar disponibilidade.",
    };
  }

  if (
    intervaloMinutos > 0 &&
    !horarioAlinhadoComGrade(horaMin, aberturaMin, intervaloMinutos)
  ) {
    const proximoMin = calcularProximoHorarioGrade({
      horaMinutos: horaMin,
      aberturaMinutos: aberturaMin,
      intervaloMinutos,
      fechamentoMinutos: fechamentoMin,
    });
    const proximoHorario =
      proximoMin != null ? minutosParaHora(proximoMin) : null;

    return {
      valido: false,
      mensagem: proximoHorario
        ? `Horário ${horaNorm} não faz parte da grade de ${intervaloMinutos} minutos a partir de ${abertura}. Próximo horário válido: ${proximoHorario}.`
        : `Horário ${horaNorm} não faz parte da grade de ${intervaloMinutos} minutos a partir de ${abertura}.`,
      proximoHorario,
    };
  }

  for (const existente of horariosExistentes) {
    const existenteNorm = normalizarHora(existente);
    if (!existenteNorm) continue;
    if (horaIgnorar && existenteNorm === normalizarHora(horaIgnorar)) continue;

    const existenteMin = horaParaMinutos(existenteNorm);
    if (existenteMin == null) continue;

    const diferenca = Math.abs(horaMin - existenteMin);
    if (diferenca > 0 && intervaloMinutos > 0 && diferenca < intervaloMinutos) {
      const proximoMin = calcularProximoHorarioGrade({
        horaMinutos: existenteMin + intervaloMinutos,
        aberturaMinutos: aberturaMin,
        intervaloMinutos,
        fechamentoMinutos: fechamentoMin,
      });
      const proximoHorario =
        proximoMin != null
          ? minutosParaHora(proximoMin)
          : minutosParaHora(existenteMin + intervaloMinutos);

      return {
        valido: false,
        mensagem: `Horário ${horaNorm} está muito próximo de ${existenteNorm}. Com intervalo de ${intervaloMinutos} min, use ${proximoHorario} ou outro horário da grade.`,
        proximoHorario,
      };
    }
  }

  return { valido: true, mensagem: "" };
};
